import { useCallback, useEffect } from "react";

/**
 * Enables capturing the ] key to toggle the AI sidebar
 */
export const useAISidebarToggleShortcut = (setTriggered: (value: boolean) => void) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "]") {
                return;
            }

            const isInputElement =
                event.target instanceof HTMLInputElement ||
                event.target instanceof HTMLTextAreaElement ||
                (event.target instanceof HTMLElement && event.target.isContentEditable);
            if (isInputElement) {
                return;
            }

            if (event.defaultPrevented) {
                return;
            }
            event.preventDefault();
            setTriggered(true);
        },
        [setTriggered],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
